import TransactionService from "@/services/transaction.service";
import RetailService from "@/services/retail.service";
import GameService from "@/services/game.service";
// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
    data() {
        return {
            printBet: false,
            isModalCustomClass: false,
            showModalBetslip: false,
            listBetslips: [],
            listDataBetslipsRetail: [],
            listDataPrintRetail: [],
            resTransaction: {},
            commonStake: 0,
            totalStake: 0,
            isDisableProcessBet: false,
            isDisableProcessBetMin: false,
            showModalProcessBet: false,
            showModalConfirmBet: false,
            refBetConfirmationDetail: '',
            loadingProcessBet: false,
            loadingBootABet: false,
            nextDraws: {},
            drawsExpired: [],
            betDraws: [],
            bets: [],
            isShowErrorExpired: false,
            isShowResBookABet: false,
            bookingCodeBootABet: null,
            accountSettings: {},
            loadingBookTicket: false,
            listGamesToShow: [],
            listGames: [],
            listBetslipsRetail: [],
            marketSelectedMain: {},
            marketSelectedAdditional: {},
            gamesSlug: [],
            isShowNotifyQuickAdd: false,
            payout_max: 500000,
            dataPrint: [],
            betMax: 0,
            betMin: 0,
        };
    },
    watch: {
        listDataBetslipsRetail(val) {
            if(val) {
                let total = 0;
                val.forEach(item => {
                    total = total + parseInt(item.stake)
                })
                this.totalStake = total;
            }
        },
        settings(val) {
            if (val) {
                if(Number(val.bet_max) > 0) {
                    this.betMax = Number(val.bet_max);
                }
                if(Number(val.bet_min) > 0) {
                    this.betMin = Number(0.5);
                }
                this.accountSettings = val;
            }
            if (parseInt(val.payout_max) > 0) {
                this.payout_max = val.payout_max;
            }
        }
    },
    created() {
        const parameters = this.$route.query
        if (parameters) {
            this.$store.dispatch('initDataCustomer', parameters)
        }
        this.$store.dispatch('apiGetSettings');
    },
    computed: {
        draws() {
            return this.$store.getters.getDraws
        },
        settings() {
            return this.$store.getters.getSettings
        },
    },
    methods: {
        getInitialLoad(type) {
            GameService.apiGetGames().then(res=> {
                // res.forEach((item, index)=> {
                //     item.isSelect = index === 0;
                //     if(index === 0) {
                //         if(type==='main') {
                //             this.marketSelectedMain = item;
                //             this.gamesSlug=[item.gameSlug]
                //             this.getRetailMarkets(this.gamesSlug);
                //         }
                //         if (type==='additional'){
                //             this.marketSelectedAdditional = item;
                //             this.handleGetMarkets(item.gameSlug);
                //         }
                //     }
                // })
                this.listGamesToShow = res;
                this.listGames = res;
            })
        },
        handlePrint() {
            const data = JSON.parse(JSON.stringify(this.dataPrint));
            window.parent.postMessage({'event': 'print-yourbetslip', 'data': data}, '*');
        },
        handleCloseYourbetslip() {
          this.showModalBetslip = false;
          this.printBet = false;
          this.bets = [];
          this.betDraws = [];
          this.resTransaction = {};
        },
        processBetslipTransat() {
            this.betDraws = [];
            this.bets = [];
            this.loadingProcessBet = true;
            this.listDataBetslipsRetail.forEach(item => {
                const { maxStake, toWin, name, draw_date, ...newItem } = item;
                this.betDraws.push(item.startDrawId);
                this.betDraws = this.betDraws.filter((item, index) => this.betDraws.indexOf(item) === index);
                if (this.bets.some(e => e.slug === item.game_slug)) {
                    this.bets.forEach(bet=> {
                        if(bet.slug === item.game_slug) {
                            bet.entries = [...bet.entries, newItem]
                        }
                    })
                } else {
                    this.bets.push(
                        {
                            slug: item.game_slug,
                            systemType: item.betType,
                            price: this.totalStake,
                            entries: [newItem]
                        }
                    )
                }
            })
            TransactionService.apiSubmitTransaction({bets: this.bets, draws: this.betDraws, additionalInformation: {
                    admin_user_id: this.$route.query.admin_user_id,
                    is_retail: this.$route.query.is_retail,
                    cashier_name: this.$route.query.cashier_name,
                    cashier_name_for_printer: this.$route.query.cashier_name_for_printer
                }}).then(res => {
                if (res.status === "success") {
                    this.dataPrint = res.data;
                    this.printBet = this.$route.query.printBet;
                    this.$toast.success(res.message, { position: 'top-right' })
                    // this.showModalBetslip = false;
                    this.listDataBetslipsRetail = [];
                    this.resTransaction = res.params;
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                    this.$store.dispatch('changeBadgeNumberRetail', this.listDataBetslipsRetail.length);
                    this.$store.dispatch('addDataToCartRetail', []);
                    localStorage.setItem('listBetslipsRetail', [])
                } else {
                    if(res.status === "error") {
                        if(res.excluded_products) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.excluded_products.forEach(item => {
                                    if(item === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.invalid_bets) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.invalid_bets.forEach(item => {
                                    if(item.market_id === bet.market && item.outcome_id === bet.outcome && item.slug === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.next_draws) {
                            this.nextDraws = res.next_draws;
                        }
                        if(res.draws) {
                            this.drawsExpired = res.draws;
                            this.listDataBetslipsRetail.forEach(bet => {
                                res.draws.forEach(draw => {
                                    if(bet.startDrawId === draw) {
                                        bet.isBetExpired = true;
                                    }
                                })
                            })
                        }
                    }
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                    this.$toast.error(res.message, {position: 'top-right'})
                }
                this.checkExpired(this.listDataBetslipsRetail);
                this.loadingProcessBet = false;
            })
        },
        handleProcessBetRetail(type) {
            let dataRetail =[];
            if(this.$store.getters.getCartRetail.length > 0) {
                dataRetail = this.$store.getters.getCartRetail;
            } else {
                let listBetslipsRetail = localStorage.getItem('listBetslipsRetail')
                listBetslipsRetail = JSON.parse(listBetslipsRetail);
                dataRetail = listBetslipsRetail;
            }
            RetailService.retailBetslipMarkets(dataRetail).then(res => {
                if (res.status === "success") {
                    this.listBetslipsRetail = [];
                    this.$store.dispatch('addDataToCartRetail', this.listBetslipsRetail);
                    let yourBetslipStorage = localStorage.getItem('yourBetslipRetail')
                    if(yourBetslipStorage && yourBetslipStorage.length > 0) {
                        yourBetslipStorage = JSON.parse(yourBetslipStorage);
                        this.listDataBetslipsRetail = yourBetslipStorage;
                    }
                    // this.$toast.success(res.message, { position: 'top-right' })
                    for (const [_, bet ] of Object.entries(res.data)) {
                        for (const [_, v] of Object.entries(bet.bets)) {
                            if(parseInt(v.maxPayout) > 0) {
                                v.maxStake = Number(v.maxPayout) / Number(v.odds);
                            } else {
                                v.maxStake = Number(v.stake) * Number(v.odds);
                            }
                            v.toWin = Number(v.stake) * Number(v.odds);
                            v.errorPayoutMax = v.toWin > this.payout_max;
                            v.payout_max = this.payout_max;
                            v.name = bet.name;
                            v.draw_date = bet.draw_date;
                            v.numOfBets = 1;
                            v.isFreeBet = 1;
                            v.game_slug = bet.game_slug;
                            this.listDataBetslipsRetail = [...this.listDataBetslipsRetail, v];
                        }
                    }
                    if(type==='quick-add') {
                        this.isShowNotifyQuickAdd = true;
                    }
                    this.$store.dispatch('changeBadgeNumberRetail', this.listDataBetslipsRetail.length);
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                } else {
                    if(res.status === "error") {
                        if(res.excluded_products) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.excluded_products.forEach(item => {
                                    if(item === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.invalid_bets) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.invalid_bets.forEach(item => {
                                    if(item.market_id === bet.market && item.outcome_id === bet.outcome && item.slug === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.next_draws) {
                            this.nextDraws = res.next_draws;
                        }
                        if(res.draws) {
                            this.drawsExpired = res.draws;
                            this.listDataBetslipsRetail.forEach(bet => {
                                res.draws.forEach(draw => {
                                    if(bet.startDrawId === draw) {
                                        bet.isBetExpired = true;
                                    }
                                })
                            })
                        }
                    }
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                    this.$toast.error(res.message, {position: 'top-right'})
                }
                this.checkExpired(this.listDataBetslipsRetail);
                this.loadingProcessBet = false;
            })
            setTimeout(() => {
                this.isShowNotifyQuickAdd = false;
            }, 5000);
        },
        handleToggleClassModal(value) {
            this.isModalCustomClass = value;
        },
        handleRemoveItemBetslip(value) {
            this.listDataBetslipsRetail = this.listDataBetslipsRetail.filter((item, index)=> index !== value);
            localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
            this.saveBetslipsToStore()
            this.checkExpired(this.listDataBetslipsRetail);
        },
        handleRemoveAllBetslips() {
            this.isShowResBookABet = false;
            this.listDataBetslipsRetail = []
            localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
            this.saveBetslipsToStore()
            this.checkExpired(this.listDataBetslipsRetail);
        },
        removeDrawsExpired() {
            this.listDataBetslipsRetail = this.listDataBetslipsRetail.filter(bet=> !this.drawsExpired.includes(bet.startDrawId))
            this.saveBetslipsToStore()
            this.checkExpired(this.listDataBetslipsRetail);
        },
        moveToNextDraw() {
            this.betDraws = [];
            this.listDataBetslipsRetail.forEach(bet=> {
                for (const [k, v] of Object.entries(this.nextDraws)) {
                    if(k === bet.game_slug) {
                        bet.startDrawId = v.external_draw_id
                        bet.isBetExpired = false;
                        bet.draw_date = v.draw_date;
                    }
                }
            })
            this.checkExpired(this.listDataBetslipsRetail);
            this.saveBetslipsToStore()
        },
        saveBetslipsToStore() {
            localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
            this.$store.dispatch('changeBadgeNumberRetail', this.listDataBetslipsRetail.length);
        },
        handleConfirmItem(ref) {
            this.refBetConfirmationDetail = ref;
            this.showModalBetslip = false;
            this.showModalProcessBet = false;
            this.showModalConfirmBet = true;
        },
        handleViewBetSlip() {
            let yourBetslipStorage = localStorage.getItem('yourBetslipRetail')
            if(yourBetslipStorage) {
                yourBetslipStorage = JSON.parse(yourBetslipStorage)
                this.listDataBetslipsRetail = yourBetslipStorage;
                const even = (element) => element.stake > element.maxStake || element.toWin > this.payout_max || element.stake < this.betMin || element.stake === 0
                    || element.stake === null || element.stake === '';
                this.isDisableProcessBet = this.listDataBetslipsRetail.some(even);
            } else {
                this.isDisableProcessBet = true;
            }
            this.showModalBetslip = true
        },
        handleBookABet() {
            this.loadingBootABet = true;
            let listData = [];
            listData = this.listDataBetslipsRetail.map(betslip => {
                let listMarketOdds = [];
                let maxPayout = null;
                for (const property in betslip?.bets?.outcomes) {
                    if(Number(betslip.odds) === Number(betslip?.bets?.outcomes[property].odds)) {
                        maxPayout = betslip?.bets?.outcomes[property].max_payout;
                    }
                    listMarketOdds.push(betslip?.bets?.outcomes[property].odds);
                }
                const bets = {
                    has_number_selection: betslip?.bets?.select_numbers,
                    selection: [{
                        numbers: betslip.numbers,
                        description: betslip?.bets?.description,
                        summary: betslip?.bets?.summary,
                        outcomeId: betslip.outcome,
                        specifier: betslip?.bets?.specifier,
                        to_win: betslip.toWin,
                        odds: betslip.odds,
                        text: betslip.text,
                        stake: betslip.stake,
                        draws: betslip.draws,
                        numOfBets: betslip.numOfBets,
                        totalCombinations: 0, // todo update
                        payoutList: [], // todo update
                        systemBets: betslip.systemBets,
                        newSystemBets: {}, // todo update
                        isFreeBet: betslip.isFreeBet,
                        wheelingId: betslip.wheelingId,
                        maxPayout: maxPayout,
                        hasData: true, // todo update,
                        newDrawName: betslip.newDrawName
                    }],
                    numOfBets: betslip.numOfBets,
                    marketOdds: listMarketOdds,
                    betType: betslip.betType,
                    nextIndex: 0, // todo update,
                    market: betslip.market,
                }
                return {
                    name: betslip.drawName,
                    slug: betslip.slug,
                    draw_id: betslip.startDrawId,
                    draw_date: betslip.drawDate,
                    bets: [bets]
                };
            })

            let listBookABets = listData.reduce(function(o, cur) {
                const occurs = o.reduce(function(n, item, i) {
                    return (item.draw_id === cur.draw_id) ? i : n;
                }, -1);
                if (occurs >= 0) {
                    o[occurs].bets = o[occurs].bets.concat(cur.bets);
                } else {
                    const obj = {
                        name: cur.name,
                        slug: cur.slug,
                        draw_id: cur.draw_id,
                        draw_date: cur.draw_date,
                        bets: cur.bets
                    };
                    o = o.concat([obj]);
                }
                return o;
            }, []);

            listBookABets.forEach(bet => {
                bet.bets = bet.bets.reduce(function(o, cur) {
                    const occurs = o.reduce(function(n, item, i) {
                        return (item.market === cur.market) ? i : n;
                    }, -1);
                    if (occurs >= 0) {
                        o[occurs].selection = o[occurs].selection.concat(cur.selection);
                    } else {
                        const obj = {
                            betType: cur.betType,
                            has_number_selection: cur.has_number_selection,
                            market: cur.market,
                            marketOdds: cur.marketOdds,
                            numOfBets: cur.numOfBets,
                            selection: cur.selection
                        };
                        o = o.concat([obj]);
                    }
                    return o;
                }, []);
                bet.bets = bet.bets.map(itemBet => {
                    return {[itemBet.market]: itemBet}
                })
            })

            TransactionService.apiBookABet(listBookABets, this.totalStake).then(res=> {
                if (res.status === "success") {
                    this.isShowResBookABet = true;
                    this.bookingCodeBootABet = res.reference;
                } else {
                    if(res.status === "error") {
                        if(res.excluded_products) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.excluded_products.forEach(item => {
                                    if(item === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.invalid_bets) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.invalid_bets.forEach(item => {
                                    if(item.market_id === bet.market && item.outcome_id === bet.outcome && item.slug === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.next_draws) {
                            this.nextDraws = res.next_draws;
                        }
                        if(res.draws) {
                            this.drawsExpired = res.draws;
                            this.listDataBetslipsRetail.forEach(bet => {
                                res.draws.forEach(draw => {
                                    if(bet.startDrawId === draw) {
                                        bet.isBetExpired = true;
                                    }
                                })
                            })
                        }
                    }
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                    this.$toast.error(res.message, {position: 'top-right'});
                    this.checkExpired(this.listDataBetslipsRetail);

                }
                this.loadingBootABet = false;
            })
        },
        handleProcessBet() {
            this.betDraws = [];
            this.bets = [];
            this.loadingProcessBet = true;
            this.listDataBetslipsRetail.forEach(item => {
                const { bets, drawDate, newDrawName, key, slug, Main, shortText, Extra, drawName, maxStake, toWin, moreDrawName, ...newItem } = item;
                this.betDraws.push(item.startDrawId)
                this.betDraws = this.betDraws.filter((item, index) => this.betDraws.indexOf(item) === index);
                if (this.bets.some(e => e.slug === item.slug)) {
                    this.bets.forEach(bet=> {
                        if(bet.slug === item.slug) {
                            bet.entries.push(newItem)
                        }
                    })
                } else {
                    this.bets.push(
                        {
                            slug: item.slug,
                            systemType: "Single",
                            price: this.totalStake,
                            entries: [newItem]
                        }
                    )
                }
            })
            TransactionService.apiSubmitTransaction({bets: this.bets, draws: this.betDraws, additionalInformation: {
                    admin_user_id: this.$route.query.admin_user_id,
                    is_retail: this.$route.query.is_retail,
                    cashier_name: this.$route.query.cashier_name,
                    cashier_name_for_printer: this.$route.query.cashier_name_for_printer
                }}).then(res => {
                if (res.status === "success") {
                    this.$toast.success(res.message, { position: 'top-right' })
                    this.showModalBetslip = false;
                    this.showModalProcessBet = true;
                    this.listDataBetslipsRetail = [];
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                } else {
                    if(res.status === "error") {
                        if(res.excluded_products) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.excluded_products.forEach(item => {
                                    if(item === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.invalid_bets) {
                            this.listDataBetslipsRetail.forEach(bet=> {
                                res.invalid_bets.forEach(item => {
                                    if(item.market_id === bet.market && item.outcome_id === bet.outcome && item.slug === bet.slug) {
                                        bet.isErrorBet = true;
                                    }
                                })
                            })
                        }
                        if(res.next_draws) {
                            this.nextDraws = res.next_draws;
                        }
                        if(res.draws) {
                            this.drawsExpired = res.draws;
                            this.listDataBetslipsRetail.forEach(bet => {
                                res.draws.forEach(draw => {
                                    if(bet.startDrawId === draw) {
                                        bet.isBetExpired = true;
                                    }
                                })
                            })
                        }
                    }
                    localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
                    this.$toast.error(res.message, {position: 'top-right'})
                }
                this.checkExpired(this.listDataBetslipsRetail);
                this.loadingProcessBet = false;
            })
        },
        checkExpired(data) {
            const even = (element) => element.isBetExpired === true;
            this.isShowErrorExpired = data.some(even);
        },
        handleLogin() {
            this.showModalBetslip = false;
            this.$router.push('Login')
        },
        async handleChangeStake(value) {
            switch (value.type) {
                case 'common': {
                    this.totalStake = value.val * this.listDataBetslipsRetail.length;
                    this.listDataBetslipsRetail.forEach(item => {
                        let stake = value.val;
                        if (stake >= 0) {
                            item.stake = this.$filters.formatNumber(Number(stake));
                        } else {
                            if(typeof stake === 'string')  {
                                stake = Number(item.stake.replace(/,/g, ""))
                                item.stake = this.$filters.formatNumber(Number(stake));
                            } else {
                                stake = 1;
                                item.stake = this.$filters.formatNumber(1);
                            }
                        }
                        item.toWin = stake * Number(item.odds);
                        item.errorPayoutMax = item.toWin > this.payout_max;
                        item.payout_max = this.payout_max;
                        item.paid = stake;
                        item.error = stake > item.maxStake;
                        item.errorMin = stake < this.betMin;
                        item.betMin = this.betMin;
                        this.isDisableProcessBet = item.error || item.errorMin;
                    })
                    break;
                }
                case 'total': {
                    this.totalStake = Number(value.val);
                    let stake = Number(value.val) / this.listDataBetslipsRetail.length;
                    this.listDataBetslipsRetail.forEach(item=> {
                        if (stake >= 0) {
                            item.stake = this.$filters.formatNumber(Number(stake));
                        } else {
                            if(typeof stake === 'string')  {
                                stake = Number(item.stake.replace(/,/g, ""))
                                item.stake = this.$filters.formatNumber(Number(stake));
                            } else {
                                stake = 1;
                                item.stake = this.$filters.formatNumber(1);
                            }
                        }
                        item.toWin = stake * Number(item.odds);
                        item.errorPayoutMax = item.toWin > this.payout_max;
                        item.payout_max = this.payout_max;
                        item.paid = stake;
                        item.error = stake > item.maxStake;
                        item.errorMin = stake < this.betMin;
                        item.betMin = this.betMin;
                        this.isDisableProcessBet = item.error || item.errorMin;
                    })
                    break;
                }
                case 'list': {
                    this.listDataBetslipsRetail = value.val;
                    this.listDataBetslipsRetail.forEach(item => {
                        let stake = item.stake
                        if (stake >= 0) {
                            item.stake = this.$filters.formatNumber(Number(stake));
                        } else {
                            if(typeof stake === 'string')  {
                                stake = Number(item.stake.replace(/,/g, ""))
                                item.stake = this.$filters.formatNumber(Number(stake));
                            } else {
                                stake = 1;
                                item.stake = this.$filters.formatNumber(1);
                            }
                        }
                        item.toWin = stake * Number(item.odds);
                        item.errorPayoutMax = item.toWin > this.payout_max;
                        item.payout_max = this.payout_max;
                        item.paid = stake;
                        item.error = stake > item.maxStake;
                        item.errorMin = stake < this.betMin;
                        item.betMin = this.betMin;
                        this.isDisableProcessBet = item.error || item.errorMin;
                    })
                    this.totalStake = value.totalStake;
                    break;
                }
            }
            const even = (element) => element.stake > element.maxStake || element.toWin > this.payout_max || element.stake < this.betMin || Number(element.stake) === 0
                || element.stake === null || element.stake === '' || element.error;
            this.isDisableProcessBet = this.listDataBetslipsRetail.some(even);
            localStorage.setItem('yourBetslipRetail', JSON.stringify(this.listDataBetslipsRetail))
        }
    }
};
